import { LegalLayout } from "@/components/legal/LegalLayout";
import { useI18n } from "@/i18n";

export default function LegalNotice() {
  const { t } = useI18n();
  return <LegalLayout page="legal" path="/legal" content={t("legal.notice")} testid="legal-page" />;
}
